import { h, Fragment } from 'preact';
import { useTranslation } from '@/hooks/useTransition';
import { registerPatternDecoder } from './index';
import { defaultCoinImage } from '@/assets/coin';
import { Trans } from '@/components/i18n';

const i18nTransSlotRegex = /^\{slot-i18ntran-(.+?)\}/;
type I18nTransRendererProps = {
  i18nKey: string;
  i18nParams: Record<string, string | number>;
  imgMap?: Record<string, (...args: any[]) => preact.ComponentChildren>;
  fallbackText: string;
};

const I18nTransRenderer = ({ i18nKey, i18nParams, imgMap = {}, fallbackText }: I18nTransRendererProps) => {
  const { t } = useTranslation();

  const text = t(i18nKey);
  const imgMapValues = Object.entries(imgMap).reduce((acc, [key, value]) => {
    acc[key] = value(i18nParams[key]);
    return acc;
  }, {} as Record<string, preact.ComponentChildren>);

  return (
    <Trans
      children={text || fallbackText}
      values={{
        ...i18nParams,
        ...imgMapValues
      }}
    />
  );
};

const DefaultImgMap = {
  coin: (coin: number) => (
    <>
      <img
        src={defaultCoinImage}
        alt="coin"
        style={{ width: 16, height: 16, marginRight: 2, textAlign: 'center' }}
      />{' '}
      {coin} Jolicoin
    </>
  )
};

registerPatternDecoder(i18nTransSlotRegex, (match, options) => {
  const i18nKey = match[1];

  if (!i18nKey) {
    return <span>{options?.text ?? ''}</span>;
  }
  return (
    <I18nTransRenderer
      i18nKey={i18nKey}
      i18nParams={options?.i18nParams}
      imgMap={options?.imgMap ?? DefaultImgMap}
      fallbackText={`[${i18nKey}]`}
    />
  );
});
